import { FaArrowDown, FaArrowUp } from "react-icons/fa";

const SortSwitch = ({  onChange, sortOrder }) => {
  
  const toggleSortOrder = () => {
    const newOrder = sortOrder === "asc" ? "desc" : "asc";
    onChange(newOrder);
  };
  
  return (
    <div className="sort-switch" onClick={toggleSortOrder}>
      <div className={`switch-circle ${sortOrder === "asc" ? "up" : "down"}`}></div>
        <FaArrowUp className={`sort-arrow-up`} />
        <FaArrowDown className={`sort-arrow-down`} />
    </div>
  );
};
  
  export default SortSwitch;
  